<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" :closable="!modalLoading"
    :mask-closable="!modalLoading" :okText="getTranslation('b181')" :cancelText="getTranslation('b182')"
    :title="getTranslation('r118')">
   
    <Row class="field-line" type="flex">
      <Col flex="1">
      <i-switch type="info" v-model="showExpulsionPoint" />&nbsp;{{ getTranslation('r118') }}
      </Col>
    </Row>

  </Modal>

</template>
<script>

import { Modal, Row, Col, Switch } from 'view-design';
import { mapGetters } from 'vuex'

export default {
  name: 'UserEdit', // 组件名称
  components: {
    Modal, Row, Col, 'i-switch': Switch,
  },
  props: {
    propVisible: Boolean,
  },
  data() {
    return {
      user: {},
      modalLoading: true,
      mac: null,
      showExpulsionPoint: false,

    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.getSetting()
      }
    }
  },

  created() {
    this.mac = this.$route.query.mac
  },
  methods: {
    getSetting() {
      this.showExpulsionPoint = localStorage.getItem('running.showExpulsionPoint') != '0';
      this.modalLoading = false;
    },
    ok() {
      let _this = this;
      localStorage.setItem('running.showExpulsionPoint', this.showExpulsionPoint ? '1' : '0');
      this.modalLoading = false;
      this.$Message.success(this.getTranslation('r091'));
      this.visible = false
      _this.$emit("set-success")
    },   
    cancel() {

    }
  },

}
</script>

<style scoped>
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
  font-weight: 550;
}

.field-line {
  margin-bottom: 8px;
}
</style>